module.exports = __webpack_public_path__ + "static/media/shangyou-shi-VdRex9AiBOc-unsplash.ed9d688c.jpg";